export default __webpack_public_path__ + "static/media/no-data-pin.3ef8af1f.svg";